import { MapTouchEvent } from 'mapbox-gl'

export interface IMapLongPressOptions {
  delayMs: number
  // Cancel when the grabbed geographic point drifts more than this on screen —
  // the user panned the map rather than held a spot.
  moveCancelPx: number
  onLongPress: (lngLat: { lat: number; lng: number }) => void
}

export interface IMapLongPressRecognizer {
  // Arm the timer for a touch. The caller gates this (single finger, not over
  // a marker, etc.) — the recognizer only owns the hold-without-pan detection.
  onTouchStart(event: MapTouchEvent): void
  // Disarm (touch end / unmount / new gesture).
  cancel(): void
}

// Single-finger hold that doesn't pan: the pressed point is re-projected when the
// timer fires — a pan drifts it past moveCancelPx, so no move-event tracking needed.
export function createMapLongPressRecognizer(
  options: IMapLongPressOptions,
): IMapLongPressRecognizer {
  let timer: number = null

  const cancel = (): void => {
    if (timer) {
      window.clearTimeout(timer)
      timer = null
    }
  }

  return {
    cancel,
    onTouchStart(event: MapTouchEvent): void {
      cancel()
      const map = event.target
      const { x: startX, y: startY } = event.point
      const lngLat = event.lngLat
      timer = window.setTimeout(() => {
        timer = null
        const now = map.project(lngLat)
        const movedPx = Math.hypot(now.x - startX, now.y - startY)
        if (movedPx <= options.moveCancelPx) {
          options.onLongPress(lngLat)
        }
      }, options.delayMs)
    },
  }
}
